import { effect, inject, Injectable, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateConfigService } from 'app/common/translate/translate-config.service';
import { environment } from 'environments/environment';

export interface Message {
  message: string;
  type: 'success' | 'error';
}

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private snackBar = inject(MatSnackBar);

  infoMessageDuration = environment.infoMessageDuration;

  private isMessageVisible = signal(false);
  private messageStack = signal<Message[]>([]);
  private translateConfigService = inject(TranslateConfigService);

  constructor() {
    effect(() => {
      const messages = this.messageStack();
      const isActive = this.isMessageVisible();

      if (isActive || messages.length === 0) return;

      const firstMessage = messages[0];

      this.isMessageVisible.set(true);

      const snackRef = this.snackBar.open(firstMessage.message, 'x', {
        duration: firstMessage.type === 'error' ? 0 : this.infoMessageDuration * 1000,
        panelClass: firstMessage.type === 'error' ? 'snackbar-error' : 'snackbar-success',
      });
      snackRef.afterDismissed().subscribe(() => {
        this.isMessageVisible.set(false);
        this.messageStack.update((stack) => stack.slice(1));
      });
    });
  }

  showSuccess(message: string) {
    const translated = this.translateConfigService.getTranslation(message);
    this.messageStack.update((stack) => [...stack, { message: translated, type: 'success' }]);
  }

  showError(message: string) {
    const translated = this.translateConfigService.getTranslation(message);
    this.messageStack.update((stack) => [...stack, { message: translated, type: 'error' }]);
  }
}
